import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  selectedAddOns: [],
}

const addOnsSlice = createSlice({
  name: 'addOns',
  initialState,
  reducers: {
    addAddOn: (state, action) => {
      console.log("addOnsSlice - Adding AddOn:", action.payload)
      const exists = state.selectedAddOns.find(
        (item) => item.title === action.payload.title
      )
      if (!exists) {
        state.selectedAddOns.push(action.payload)
      }
    },
    removeAddOn: (state, action) => {
      state.selectedAddOns = state.selectedAddOns.filter(
        (item) => item.title !== action.payload.title
      )
    },
    clearAddOns: (state) => {
      state.selectedAddOns = []
    },
    updateAddOnPrice: (state, action) => {
      const { title, price } = action.payload
      const addOn = state.selectedAddOns.find((item) => item.title === title)
      if (addOn) {
        addOn.price = price
      }
    },
    // reducer to set multiple add-ons at once
    setAddOns: (state, action) => {
      console.log("addOnsSlice - Setting AddOns:", action.payload)
      state.selectedAddOns = action.payload || []
    },
  },
})

export const { setAddOns, addAddOn, removeAddOn, clearAddOns, updateAddOnPrice } = addOnsSlice.actions
export default addOnsSlice.reducer
